var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ 'Button whiter flex-row': _vm.whiteText, Button: !_vm.whiteText },style:({
    backgroundColor: _vm.fill ? `#${_vm.color}` : 'transparent',
    boxShadow: `1px 1px 20px #${_vm.color}80`,
    border: `2px solid #${_vm.color}`,
    width: _vm.stretch ? '100%' : '',
  }),attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('clicked')}}},[(_vm.icon)?_c('ImageVue',{attrs:{"src":_vm.icon,"size":'20px'}}):_vm._e(),(_vm.icon)?_c('div',{staticClass:"gap-left"}):_vm._e(),(_vm.loading)?_c('ImageVue',{staticClass:"loading",attrs:{"src":'dynamic/loading_white.svg',"size":"30px"}}):_c('a',{staticClass:"p",style:({ color: _vm.textColor })},[_vm._v(" "+_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }